import { Component, inject, Inject } from '@angular/core';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TrailPersonal } from '../../dto/trail-personal';

@Component({
  selector: 'dpi-trail-personal-details',
  imports: [MatInputModule, MatFormFieldModule, FormsModule, MatButtonModule, MatIconModule, MatTooltipModule, MatDialogModule],
  templateUrl: './trail-personal-details.component.html',
  styleUrl: './trail-personal-details.component.scss'
})
export class TrailPersonalDetailsComponent {
  readonly dialogRef = inject(MatDialogRef<TrailPersonalDetailsComponent>);
  trailPersonal: TrailPersonal;
  isToUpdate: boolean;
  isToDelete: boolean;

  constructor(@Inject(MAT_DIALOG_DATA) public data: TrailPersonal) {
    this.trailPersonal = data;
    this.isToUpdate = false;
    this.isToDelete = false;
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

  onUpdateClick() {
    this.isToUpdate = true;
  }

  onDeleteClick() {
    this.isToDelete = true;
    this.dialogRef.close();
  }



}
